import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=6d34ed8e&scoped=true"
import script from "./TypeList.vue?vue&type=script&lang=js"
export * from "./TypeList.vue?vue&type=script&lang=js"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=6d34ed8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34ed8e",
  null
  
)

export default component.exports